export default __webpack_public_path__ + "cbe144ba5aa8a9b64f41d986c5b5b243.png";